/* analytics.js - Umami Custom Events
   - Sendet nur im Production-Build und nur, wenn das Umami-Script geladen ist
   - Tracking darf die App nie stören: Fehler werden verschluckt
*/
export const trackEvent = (name, data) => {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }
  try {
    if (window.umami && typeof window.umami.track === 'function') {
      window.umami.track(name, data);
    }
  } catch (err) {
    // Tracking-Fehler bewusst ignorieren
  }
};

// Props für einen Link, dessen Öffnen getrackt werden soll. Linksklick inkl.
// Strg/Shift/Cmd läuft über onClick, Mittelklick über onAuxClick mit
// button === 1; Browser feuern für die mittlere Taste kein click-Event,
// deshalb zählt kein Klick doppelt. Rechtsklick (Kontextmenü) zählt nicht.
// Das Öffnen selbst wird nicht beeinflusst. Ohne onTrack: keine Handler.
export const trackedLinkProps = (onTrack) =>
  onTrack
    ? {
        onClick: () => onTrack(),
        onAuxClick: (e) => {
          if (e.button === 1) onTrack();
        },
      }
    : {};

// Zuletzt angezeigte Aktivität, damit Komponenten ausserhalb von ActivityDetail
// (z.B. der PDF-Button im Header) deren event_type mitsenden können.
let currentActivity = null;

export const setCurrentActivity = (id, eventType) => {
  currentActivity = { id: String(id), event_type: eventType };
};

export const getCurrentActivityEventType = (id) =>
  currentActivity && currentActivity.id === String(id) ? currentActivity.event_type : undefined;
